function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Story-editor-open-pages",
  transform: "translate(-269.000000, -76.000000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M284.885,76.885 C284.315,76.315 283.55,76 282.755,76 L272,76 C270.35,76 269,77.35 269,79 L269,103 C269,104.65 270.335,106 271.985,106 L290,106 C291.65,106 293,104.65 293,103 L293,86.245 C293,85.45 292.685,84.685 292.115,84.13 L284.885,76.885 Z M285.5,100 L276.5,100 C275.675,100 275,99.325 275,98.5 C275,97.675 275.675,97 276.5,97 L285.5,97 C286.325,97 287,97.675 287,98.5 C287,99.325 286.325,100 285.5,100 Z M285.5,94 L276.5,94 C275.675,94 275,93.325 275,92.5 C275,91.675 275.675,91 276.5,91 L285.5,91 C286.325,91 287,91.675 287,92.5 C287,93.325 286.325,94 285.5,94 Z M282.5,85 L282.5,78.25 L290.75,86.5 L284,86.5 C283.175,86.5 282.5,85.825 282.5,85 Z",
  id: "page-2"
})));

var SvgPages = function SvgPages(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "30px",
    viewBox: "0 0 24 30",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPages, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pages.d1d7d2b4.svg";
export { ForwardRef as ReactComponent };